import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';
import InputFilter from '../../../Filters/InputFilter';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import {RouterTwoTone} from '@mui/icons-material';

function Retoma({
    editarProposta,
    marcas,
    tipoContrato,
    setTipoContrato,
    arrayTipoContrato,
    lubrificantes,
    setLubrificantes,
    arrayLubrificantes,
    duracaoContrato,
    setDuracaoContrato,
    arrayDuracaoContrato,
    arrayHorasAno,
    horasAno,
    setHorasAno,
    precoHora,
    setPrecoHora,
    setOnChangeForm,
    categorias,
    setLinhasRetoma,
    linhasRetoma,

    validacaoModelo,
    setValidacaoModelo,
    validacaoNserie,
    setValidacaoNserie,
    validacaoMatricula,
    setValidacaoMatricula,
    validacaoHoras,
    setValidacaoHoras,
    validacaoAno,
    setValidacaoAno,
    validacaoValor,
    setValidacaoValor,
}) {
    const {t} = useTranslation();

    useEffect(() => {
        if (linhasRetoma.length == 0) {
            setLinhasRetoma([
                {
                    id: Math.floor(Math.random() * 999999),
                    categoria: '',
                    marca: '',
                    modelo: '',
                    nSerie: '',
                    matricula: '',
                    horas: '',
                    ano: '',
                    valor: 0,
                },
            ]);
        }
    }, []);

    const rowCount = linhasRetoma.length;

    function eliminarLinha(id) {
        setLinhasRetoma(linhasRetoma.filter(l => l.id !== id));
    }

    function adicionarLinha(id) {
        setLinhasRetoma([
            ...linhasRetoma,
            {
                id: Math.floor(Math.random() * 999999),
                categoria: '',
                marca: '',
                modelo: '',
                nSerie: '',
                matricula: '',
                horas: '',
                ano: '',
                valor: 0,
            },
        ]);
    }

    const handleChildChange = (e, id) => {
        const updatedData = [...linhasRetoma];
        updatedData[id] = e;
        setLinhasRetoma(updatedData);
    };

    return (
        <div>
            <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                        <tr>
                            <th scope="col" className="px-6 py-3">
                                {t('categoria')}
                            </th>
                            <th scope="col" className="px-6 py-3">
                                {t('marca')}
                            </th>

                            <th scope="col" className="px-6 py-3">
                                {t('modelo')}
                            </th>

                            <th scope="col" className="px-4">
                                {t('numSerie')}
                            </th>

                            <th scope="col" className="">
                                {t('matricula')}
                            </th>

                            <th scope="col" className="">
                                {t('horas')}
                            </th>

                            <th scope="col" className="">
                                {t('ano')}
                            </th>

                            <th scope="col" className="">
                                {t('valor')}
                            </th>

                            <th scope="col" className="px-6 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {linhasRetoma?.map((row, rowIndex) => {
                            return (
                                <tr
                                    key={rowIndex}
                                    className="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                                    //   onClick={() => handleRowClick(dados)}
                                >
                                    <td className="px-6 py-4">
                                        <SelectComponent
                                            options={categorias}
                                            value={row.categoria}
                                            onChange={e => {
                                                row.categoria = e;
                                                handleChildChange(row, rowIndex);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <SelectComponent
                                            options={marcas.filter(o => o.dep === row.categoria?.value)}
                                            value={row.marca}
                                            onChange={e => {
                                                row.marca = e;
                                                handleChildChange(row, rowIndex);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.modelo}
                                            placeholder={t('modelo')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.modelo == "" && validacaoModelo
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.modelo = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoModelo(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.nSerie}
                                            placeholder={t('numSerie')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.nSerie == "" && validacaoNserie
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.nSerie = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoNserie(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.matricula}
                                            placeholder={t('matricula')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.matricula == "" &&  validacaoMatricula
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.matricula = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoMatricula(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.horas}
                                            placeholder={t('horas')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.horas == "" &&  validacaoHoras
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.horas = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoHoras(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.ano}
                                            placeholder={t('ano')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.ano == "" &&  validacaoAno
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.ano = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoAno(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="number"
                                            value={row.valor}
                                            placeholder={t('valor')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700 ${
                                                row.valor == 0 && validacaoValor
                                                    ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                                    : ''
                                            }`}
                                            onChange={e => {
                                                row.valor = e.target.value;
                                                handleChildChange(row, rowIndex);
                                                setValidacaoValor(false)
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-2 py-4">
                                        {rowCount === rowIndex + 1 && row.marca !== '' && row.categoria !== '' && editarProposta && (
                                            <button className={`mt-2 rounded-full p-1 ${'bg-blue-600'} text-white`}>
                                                <AddRoundedIcon onClick={adicionarLinha} />
                                            </button>
                                        )}
                                        {rowCount != rowIndex + 1 && editarProposta && (
                                            <button
                                                onClick={e => {
                                                    eliminarLinha(row.id);
                                                    e.preventDefault();
                                                }}
                                                className={`mt-2 rounded-full p-1 ${'bg-red-600'} text-white`}>
                                                <DeleteForeverRoundedIcon />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Retoma;
